import { ChevronLeft, Mail, MapPin, Zap } from "lucide-react";
import { User } from "../types/user";

interface UserProfileHeaderProps {
    selectedUser: User;
    setSelectedUser: (user: User | null) => void;
}

export default function UserProfileHeader({ selectedUser, setSelectedUser }: UserProfileHeaderProps) {
    return (
        <div className="w-full">
            <button className="flex items-center justify-start gap-x-1 text-white text-xs my-3"
                onClick={() => setSelectedUser(null)}
            >
                <ChevronLeft size={14} />
                <p>Back</p>
            </button>
            <div className="w-full flex items-start justify-start gap-x-4 text-white p-6 bg-card rounded-xl">
                <div className="w-[120px] h-[120px] bg-white rounded-full"></div>
                <div className="flex flex-col items-start justify-start gap-y-2 text-xs border-r border-white pr-28">
                    <h1 className="font-bold text-xl py-2">{selectedUser.name}</h1>
                    <div className="flex items-center gap-x-2">
                        <Mail className="text-gray-400" size={18} />
                        <p>{selectedUser.email}</p>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <MapPin className="text-gray-400" size={18} />
                        <p>{selectedUser.country}</p>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <Zap size={18} className="text-green-500" />
                        <p className="text-green-500">Active</p>
                    </div>
                </div>

                <div className="flex flex-col items-start justify-start gap-y-2 text-xs pl-10">
                    <div className="flex items-center gap-x-2">
                        <p className="text-gray-400">Verification</p>
                        <p>Verified</p>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <p className="text-gray-400">Registration Date</p>
                        <p>{selectedUser.createdAt}</p>
                    </div>
                    <div className="flex items-center gap-x-2">
                        <p className="text-gray-400">Service</p>
                        <p>{selectedUser.service_name}</p>
                    </div>
                </div>
            </div>
        </div>
    );
}